<template>
  <div class="col-12">
    <div class="col-12 mt-3">
      <div class="row filter-row-saved py-3">
        <div
          class="col-12 mb-4 mb-md-0 col-lg-3"
          :class="isMobile && 'bg-gray rounded py-3'"
        >
          <span>Información de la localidad</span>
        </div>
        <div class="col-12 col-lg-3" :class="isMobile && 'px-0'">
          <custom-drop-down
            id="CenterId"
            v-model="model.center"
            fieldkey="value"
            fieldname="name"
            :options="collections.centers"
            :disabled="model.centerDisabled || readOnly"
            :clearable="false"
            label="Centro:"
            @input="onChangedCenter"
            :class="isMobile && 'w-100'"
          />
        </div>
        <div class="col-12 col-lg-3" :class="isMobile && 'px-0'">
          <custom-drop-down
            id="MunicipalityId"
            v-model="model.municipality"
            fieldkey="value"
            fieldname="name"
            :options="collections.municipalities"
            :disabled="this.model.municipalityDisabled || readOnly"
            :clearable="false"
            label="Municipio:"
            @input="onChangedMunicipality"
            :class="isMobile && 'w-100'"
          />
        </div>
        <div class="col-12 col-lg-3" :class="isMobile && 'px-0'">
          <custom-drop-down
            id="SchoolId"
            v-model="model.school"
            fieldkey="value"
            fieldname="name"
            :options="collections.schools"
            :disabled="this.model.schoolDisabled || readOnly"
            :clearable="false"
            label="Escuela:"
            :class="isMobile && 'w-100'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down'
import locationApi from '@/services/api/location.api'
import AcademicYearServices from '@/services/api/academicyear.api'
export default {
  name: 'LocationFilters',
  components: {
    CustomDropDown,
  },
  props: {
    collections: {
      type: Object,
      default: () => ({
        academicYears: [],
        schools: [],
        municipalities: [],
        centers: [],
      }),
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      oldTopic: 0,
      defaultValue: {
        id: null,
        name: 'Todos',
        selected: 'true',
      },
    }
  },
  computed: {
    isMobile() {
      return this.$store.getters['$_app/getIsMobileDensity']
    },
    model: {
      get() {
        return this.value || {}
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  watch: {
    'data.topic'(newValue) {
      if (this.oldTopic != newValue) {
        if (
          !this.readOnly &&
          (this.data.id === 0 ||
            this.data.id == undefined ||
            this.data.id == null)
        )
          this.clear()
      }
      this.oldTopic = newValue
    },
    'model.academicYear': {
      immediate: true,
      deep: true,
      handler(value) {
        const academicYear = {
          name: 'AcademicYearId',
          id: value?.id.toString(),
        }
        var existsAcademicYear = this.data.locationFilters?.filter(function (
          obj
        ) {
          return obj.name == 'AcademicYearId'
        })

        if (
          existsAcademicYear != undefined &&
          existsAcademicYear.length == 0 &&
          value != null
        ) {
          this.data.locationFilters.push(academicYear)
        } else if (value != null) {
          const indx = this.data.locationFilters?.indexOf(existsAcademicYear[0])
          this.data.locationFilters[indx] = academicYear
        } else if (
          value == null &&
          existsAcademicYear != undefined &&
          existsAcademicYear.length > 0
        ) {
          const indx = this.data.locationFilters?.indexOf(existsAcademicYear[0])
          this.data.locationFilters.splice(indx, 1)
        }
      },
    },
    'model.center': {
      immediate: true,
      deep: true,
      handler(value) {
        const center = {
          name: 'CenterId',
          id: value?.id.toString(),
        }

        var existsCenter = this.data.locationFilters?.filter(function (obj) {
          return obj.name == 'CenterId'
        })

        if (
          existsCenter != undefined &&
          existsCenter.length == 0 &&
          value != null
        ) {
          this.data.locationFilters.push(center)
        } else if (value != null) {
          const indx = this.data.locationFilters?.indexOf(existsCenter[0])
          this.data.locationFilters[indx] = center
        } else if (
          value == null &&
          existsCenter != undefined &&
          existsCenter.length > 0
        ) {
          const indx = this.data.locationFilters?.indexOf(existsCenter[0])
          this.data.locationFilters.splice(indx, 1)
        }

        if (this.collections.centers.length == 1 && value != null) {
          this.getMunicipalities()
        }
      },
    },
    'model.municipality': {
      immediate: true,
      deep: true,
      handler(value) {
        const municipality = {
          name: 'MunicipalityId',
          id: value?.id.toString(),
        }

        var existsMunicipality = this.data.locationFilters?.filter(function (
          obj
        ) {
          return obj.name == 'MunicipalityId'
        })

        if (
          existsMunicipality != undefined &&
          existsMunicipality.length == 0 &&
          value != null
        ) {
          this.data.locationFilters.push(municipality)
        } else if (value != null) {
          const indx = this.data.locationFilters?.indexOf(existsMunicipality[0])
          this.data.locationFilters[indx] = municipality
        } else if (
          value == null &&
          existsMunicipality != undefined &&
          existsMunicipality.length > 0
        ) {
          const indx = this.data.locationFilters?.indexOf(existsMunicipality[0])
          this.data.locationFilters.splice(indx, 1)
        }

        if (this.collections.municipalities.length == 1 && value != null) {
          this.getSchools()
        }
      },
    },
    'model.school': {
      immediate: true,
      deep: true,
      handler(value) {
        const school = {
          name: 'LocationSchoolId',
          id: value?.id.toString(),
        }

        var existsSchool = this.data.locationFilters?.filter(function (obj) {
          return obj.name == 'LocationSchoolId'
        })

        if (
          existsSchool != undefined &&
          existsSchool.length == 0 &&
          value != null
        ) {
          this.data.locationFilters.push(school)
        } else if (value != null) {
          const indx = this.data.locationFilters?.indexOf(existsSchool[0])
          this.data.locationFilters[indx] = school
        } else if (
          value == null &&
          existsSchool != undefined &&
          existsSchool.length > 0
        ) {
          const indx = this.data.locationFilters?.indexOf(existsSchool[0])
          this.data.locationFilters.splice(indx, 1)
        }
      },
    },
  },
  async mounted() {
    await this.setFilters()
  },
  methods: {
    async setFilters() {
      await AcademicYearServices.getCurrentYearAcademicYears().then((res) => {
        this.collections.academicYears = res.data
        if (this.collections.academicYears.length > 0) {
          this.model.academicYear = this.collections.academicYears[0]
          this.getCenters()
        }
      })
    },
    async getCenters() {
      await locationApi
        .getCenters({ academicYearId: this.model?.academicYear.id })
        .then((res) => {
          this.collections.centers = res.data
          this.disabledCenter(false)

          if (this.collections.centers.length == 1) {
            this.model.center = this.collections.centers[0]
          }
        })
    },
    async getMunicipalities() {
      await locationApi
        .getMunicipalities({
          academicYearId: this.model?.academicYear.id,
          centerId: this.model.center?.id,
        })
        .then((res) => {
          this.collections.municipalities = res.data

          this.disabledMunicipality(false)

          if (this.collections.municipalities.length == 1) {
            this.model.municipality = this.collections.municipalities[0]
          }
        })
    },
    async getSchools() {
      await locationApi
        .getSchools({
          academicYearId: this.model?.academicYear.id,
          centerId: this.model.center?.id,
          municipalityId: this.model.municipality?.id,
        })
        .then((res) => {
          this.collections.schools = res.data

          this.disabledSchool(false)
          if (this.collections.schools.length == 1) {
            this.model.school = this.collections.schools[0]
          }
        })
    },
    async onChangedAcademicYears() {
      this.clearCenters()
      this.clearMunicipalities()
      this.clearSchools()

      if (!this.model?.academicYear) {
        this.disabledCenter(true)
        this.disabledMunicipality(true)
        this.disabledSchool(true)
        return false
      }

      await this.getCenters()
    },
    async onChangedCenter() {
      this.clearMunicipalities()
      this.clearSchools()

      if (!this.model.center) {
        this.disabledMunicipality(true)
        this.disabledSchool(true)
        return false
      }

      await this.getMunicipalities()
    },
    async onChangedMunicipality() {
      this.clearSchools()

      if (!this.model.municipality) {
        this.disabledSchool(true)
        return false
      }
      await this.getSchools()
    },
    clearCenters() {
      this.model.center = null
      this.collections.centers = []
    },
    clearMunicipalities() {
      this.model.municipality = null
      this.collections.municipalities = []
    },
    clearSchools() {
      this.model.school = null
      this.collections.schools = []
    },
    disabledCenter(disabled) {
      this.model.centerDisabled = disabled
    },
    disabledMunicipality(disabled) {
      this.model.municipalityDisabled = disabled
    },
    disabledSchool(disabled) {
      this.model.schoolDisabled = disabled
    },
    clear() {
      this.clearMunicipalities()
      this.clearSchools()
      this.disabledMunicipality(true)
      this.disabledSchool(true)
      this.model.center = null
    },
  },
}
</script>
